import React, { useState, useRef, useEffect } from 'react';
import {
  AppBar, Toolbar, Typography, IconButton,
} from '@mui/material';
import Icon from 'screens/shared/icon';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getKey, getParam, setKey } from 'utils';
import { MEDIA_SCREENS_BREAKOUT } from 'constant';
import { getConfig } from 'utils/config';
import { actions } from 'redux/actions';
import { ACTIONS_TYPES } from 'redux/helper';
import ProfileMenuComponent from './profile-menu';
import DrawerComponent from './drawer';
import ProvisioningBar from '../provisioning-bar';
import Breadcrumb from './bread-crumb';
import ViewSwitch from './view-switch';


const noMenu = getParam('no-menu');
let noTopbar = getParam('no-topbar');

const Layout = ({ history, children }) => {
  const headerRef = useRef({});
  const [drawerOpen, setDrawerOpen] = useState(false);
  const {
    [ACTIONS_TYPES.USER.GET_CURRENT_USER]: currentUser = {},
    layout = {},
    screen = {},
  } = useSelector((e) => e);
  const { title = '' } = layout;
  const { width } = screen;
  const { features = {} } = getConfig() || {};
  const isDCD = getKey('isAccessByDCD');
  noTopbar = noTopbar || isDCD;

  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  const viewChangeHandler = (name) => {
    setKey('dcd-view', name);
    actions.common.quickUpdate({ listViewType: name });
  };

  useEffect(() => {
    if (getParam('table-view')) viewChangeHandler('table');
    if (getParam('list-view')) viewChangeHandler('tile');
    actions.common.getFeatures();
    actions.user.getCurrentUser();
  }, []);

  const heightStyles = {
    height: `calc(100vh - ${headerRef.current?.clientHeight || 0}px)`,
    minHeight: `calc(100vh - ${headerRef.current?.clientHeight || 0}px)`,
  };
  const mainStyle = noTopbar ? { ...heightStyles } : {
    marginTop: headerRef.current?.clientHeight || 55,
    paddingTop: 0,
    ...heightStyles,
  };

  useEffect(() => {
    if (currentUser.id) {
      actions.user.getGroupsForUser({ userId: currentUser.id });
    }
  }, [currentUser.id]);

  return (
    <>
      {!noTopbar && (
        <section className="header">
          <AppBar position="fixed" className={`top-bar ${noMenu ? 'no-menu' : ''}`} ref={headerRef}>
            <Toolbar>
              {(!noMenu && width < MEDIA_SCREENS_BREAKOUT.TABLET.MIN) && (
                <IconButton
                  onClick={handleDrawerOpen}
                  edge="start"
                  color="inherit"
                  aria-label="menu"
                  size="large"
                >
                  <Icon name="menu" type="material" />
                </IconButton>
              )}
              <Typography variant="h6" className="flex-grow">{title}</Typography>
              {features.tableViewSwitch && (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  <ViewSwitch onViewChange={viewChangeHandler} />
                </div>
              )}

              <ProfileMenuComponent history={history} />
            </Toolbar>
            <Breadcrumb history={history} />
          </AppBar>
          {!noMenu && (
            <DrawerComponent
              show={drawerOpen || width >= MEDIA_SCREENS_BREAKOUT.TABLET.MIN}
              onClose={handleDrawerClose}
              history={history}
            />
          )}
        </section>
      )}
      <main
        className={`${noTopbar ? 'no-topbar' : noMenu ? 'no-menu' : ''}${isDCD ? ' dcd-view' : ''}`}
        style={mainStyle}
      >
        {children}
      </main>
      <ProvisioningBar />
    </>
  );
};

export default withRouter(Layout);
